import { applyPalette, statusOf, Toaster, TooltipProvider } from '@bixo/ui'
import { useQuery } from '@tanstack/react-query'
import { Outlet } from '@tanstack/react-router'
import { useEffect, type ReactNode } from 'react'
import { tenantQuery } from '../lib/api'
import { Splash, WorkspaceNotFound, WorkspaceSuspended, WorkspaceUnavailable } from './screens'

/** Resolves the workspace from the host and applies its branding first. */
export function Root() {
  const { data: tenant, error, isPending, refetch } = useQuery(tenantQuery)

  useEffect(() => {
    if (!tenant) return
    applyPalette(tenant.palette)
    document.title = tenant.app_name || tenant.name
  }, [tenant])

  let content: ReactNode
  if (isPending) content = <Splash />
  else if (statusOf(error) === 404) content = <WorkspaceNotFound />
  else if (statusOf(error) === 423 || tenant?.status === 'suspended')
    content = <WorkspaceSuspended {...(tenant ? { name: tenant.name } : {})} />
  else if (error) content = <WorkspaceUnavailable onRetry={() => void refetch()} />
  else content = <Outlet />

  return (
    <TooltipProvider delayDuration={300}>
      {content}
      <Toaster />
    </TooltipProvider>
  )
}
